/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IHospital } from 'app/shared/model/hospital.model';

export interface ILabTestCategoryGroup {
  id?: string;
  active?: boolean;
  description?: string;
  displayKey?: string | null;
  lastupdated?: number | null;
  name?: string;
  sortOrder?: number | null;
  timestampentry?: number;
  microSec?: number;
  cursor?: number;
  hospital?: IHospital;
}

export const defaultValue: Readonly<ILabTestCategoryGroup> = {
  active: false,
};
